import React, { useEffect, useState, useRef } from "react";
import SellSystemLeads from "./sellSystemLeads.js";
import SellSystemCalendar from "./sellSystemCalendar.js";
import { secretKey, monthData } from "../.././data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

const AddSellSystemTask = (props) => {
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    props.mode === "edit"
      ? props.taskData.startDate
      : new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate())
  );
  const [finalDate, setFinalDate] = useState(
    props.mode === "edit" ? props.taskData.finalDate : ""
  );
  const [note, setNote] = useState(
    props.mode === "edit" ? props.taskData.noteTask : ""
  );
  const [taskType, setTaskType] = useState([]);
  const [users, setUsers] = useState([]);
  const [sellUsers, setSellUsers] = useState([]);
  const [responsible, setResponsible] = useState(
    props.mode === "edit" ? props.taskData.responsible : props.uData.name
  );
  const [task, setTask] = useState(
    props.mode === "edit" ? props.taskData.task : ""
  );

  const fetchTaskType = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSellTaskType", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTaskType(data);
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchSellUsers();
      })
      .catch((error) => {});
  };

  const fetchSellUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSellUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellUsers(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    if (props.mode === "edit") {
      setResponsible(props.taskData.responsible);
    } else {
      setResponsible(
        props.user.name !== undefined ? props.user.name : props.user
      );
    }
    fetchTaskType();
  };

  useEffect(() => {
    getData();
  }, []);

  const addTask = async () => {
    if (validateTask()) {
      setLoading(true);

      var body = {
        startDate: startDate,
        finalDate: finalDate,
        leadName: props.leadData.name,
        task:
          props.leadData.type === "SKD" && !task.includes("SKD")
            ? task + " - SKD"
            : task,
        responsible: responsible,
        noteTask: note,
        status: "ZLECONE",
        leadId: props.leadData.id,
        addUser: props.user,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addSellTask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "zadanie sprzedażowe",
          }).then(() => {
            props.close();
          });
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const editTask = async () => {
    if (validateTask()) {
      setLoading(true);

      var body = {
        startDate: startDate,
        finalDate: finalDate,
        leadName: props.taskData.leadName,
        task:
          props.leadData.type === "SKD"
            ? !props.taskData.task.includes("- SKD")
              ? task + " - SKD"
              : task
            : task,
        responsible: responsible,
        noteTask: note,
        status: "ZLECONE",
        leadId: props.taskData.leadId,
        addUser: props.user,
        taskId: props.taskData.id,
      };

      var bodyXX = {
        new: JSON.stringify(body),
        old: JSON.stringify(props.taskData),
        user: props.user,
        taskId: props.taskData.id,
      };

      fetch("https://apidevkppp.ftpeople.pl/addSellTaskHistory", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(bodyXX),
      })
        .then((response) => response.text())
        .then((data) => {});

      await fetch("https://apidevkppp.ftpeople.pl/editSellTask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "zadanie sprzedażowe",
          }).then(() => {
            props.close();
          });
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validateTask = () => {
    if (
      startDate.toString().length === 0 ||
      finalDate.toString().length === 0 ||
      task.length === 0 ||
      responsible.length === 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <div
        style={{ width: "50vw", paddingBottom: "5vh", top: "20vh" }}
        className="mainContainerAddClientContact"
      >
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="inputBox">
          <div style={{ minWidth: "49%" }} className="inputCol_2">
            <label>
              Data wprowadzenia
              <span className="requiredStar">*</span>
            </label>
            <input
              type="date"
              id="date"
              name="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
              min="2002-01-01"
            />
          </div>
          <div style={{ minWidth: "49%" }} className="inputCol_2">
            <label>
              Data realizacji
              <span className="requiredStar">*</span>
            </label>
            <input
              type="date"
              id="date"
              name="date"
              value={finalDate}
              onChange={(e) => {
                setFinalDate(e.target.value);
              }}
              min="2002-01-01"
            />
          </div>
        </div>
        <div className="inputBox">
          <div style={{ minWidth: "49%" }} className="inputCol_2">
            <label>
              Zadanie
              <span className="requiredStar">*</span>
            </label>
            <select
              style={{ boxSizing: "border-box" }}
              type="text"
              id="name"
              name="name"
              value={task}
              onChange={(e) => {
                setTask(e.target.value);
              }}
            >
              {!task ? (
                <>
                  <option key={0} value={0}>
                    Wybierz...
                  </option>
                </>
              ) : (
                ""
              )}
              {taskType.map((el) => (
                <>
                  <option key={el.name} value={el.name}>
                    {el.name}
                  </option>
                </>
              ))}
            </select>
          </div>
          {props.uData.adminSprzedaz === "1" ? (
            <>
              <div style={{ minWidth: "49%" }} className="inputCol_2">
                <label>
                  Pracownik
                  <span className="requiredStar">*</span>
                </label>
                <select
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={responsible}
                  onChange={(e) => {
                    setResponsible(e.target.value);
                  }}
                >
                  {!responsible ? (
                    <>
                      <option key={0} value={0}>
                        Wybierz...
                      </option>
                    </>
                  ) : (
                    ""
                  )}
                  {users.map((el) => (
                    <>
                      <option key={el.name} value={el.name}>
                        {el.name}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ""
          )}
          {props.uData.adminSprzedaz !== "1" &&
          props.uData.role !== "consultantTele" ? (
            <>
              <div style={{ minWidth: "49%" }} className="inputCol_2">
                <label>
                  Pracownik
                  <span className="requiredStar">*</span>
                </label>
                <select
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={responsible}
                  onChange={(e) => {
                    setResponsible(e.target.value);
                  }}
                >
                  {!responsible ? (
                    <>
                      <option key={0} value={0}>
                        Wybierz...
                      </option>
                    </>
                  ) : (
                    ""
                  )}

                  <option
                    key={
                      props.user
                        ? props.user.name !== undefined
                          ? props.user.name
                          : props.user
                        : props.uData.name
                    }
                    value={
                      props.user
                        ? props.user.name !== undefined
                          ? props.user.name
                          : props.user
                        : props.uData.name
                    }
                  >
                    {props.user
                      ? props.user.name !== undefined
                        ? props.user.name
                        : props.user
                      : props.uData.name}
                  </option>
                  {sellUsers.map((el) => (
                    <option key={el.name} value={el.name}>
                      {el.name}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        <div className="inputBox">
          <div className="inputCol_1">
            <label>Notatka</label>
            <textarea
              spellCheck="false"
              className="textAreaNote"
              type="text"
              id="url"
              name="url"
              value={note}
              onChange={(e) => {
                setNote(e.target.value);
              }}
            />
          </div>
        </div>
        <div
          style={{ justifyContent: "left" }}
          className="acceptButtonContainer"
        >
          <button
            style={{ backgroundColor: "white" }}
            className="acceptButton"
            onClick={props.mode === "edit" ? editTask : addTask}
          >
            {props.mode === "edit" ? "ZAPISZ ZMIANY" : "DODAJ ZADANIE"}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddSellSystemTask;
